/* unplugin-vue-components disabled */import script from "./HomeNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeNotice.vue?vue&type=script&setup=true&lang=js"

import "./HomeNotice.vue?vue&type=style&index=0&id=67ac9ae8&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/e652ddcf-2c47-4325-b31c-639f40aeccc9/workspace/mobile-FTZCOIN_ILBL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ac9ae8"]])

export default __exports__